import React from 'react';
import { TextField } from 'react-admin';

const MultilineTextField = ({ ...props }) => {
    return (
        <TextField style={{ whiteSpace: 'pre-wrap' }} {...props} />
    );
};

export default MultilineTextField;